import Color from './Color'
import Card from './Card'
import Level from './Level'
import Reward from './Reward'
import Branch from './Branch'
import ProductExchangeRate from './ProductExchangeRate'
import Promotion from './Promotion'
import Blog from './Blog'
import Package from './Package'
import PackageQRcode from './PackageQRcode'
import Editv2 from './Editv2'
import AddCoin from './AddCoin'
import Redeem from './Redeem'
import DashBroad from './DashBroad'

export default {
  Color,
  Card,
  Level,
  Reward,
  ProductExchangeRate,
  Branch,
  Promotion,
  Blog,
  Package,
  PackageQRcode,
  Editv2,
  AddCoin,
  Redeem,
  DashBroad
}



// WEBPACK FOOTER //
// ./src/components/Master/index.js